<template>
    <div>
        <pda-header :title='title'></pda-header>
        <div v-if="outData.length !== 0">
            <div>
                <div class="info-order-h">
                    <span class="right-twenty">出库单编号</span>
                    <input class="order-info-input" readonly="readonly" v-model="outData.out.out_num">
                </div>
                <div class="info-order-h">
                    <span class="right-twenty">仓库</span>
                    <input class="order-info-input" readonly="readonly" v-model="outData.out.warehouse">
                </div>
                <div class="info-order-h">
                    <span class="right-twenty">出库类型</span>
                    <input class="order-info-input" readonly="readonly" v-model="outData.out.out_type">
                </div>
                <div class="info-order-h">
                    <span class="right-twenty">关联单据</span>
                    <input class="order-info-input" readonly="readonly" v-model="outData.out.relevance">
                </div>
                <div class="info-order-h">
                    <span class="right-twenty">订单状态</span>
                    <input class="order-info-input" readonly="readonly" v-model="outData.out.status">
                </div>
            </div>
            <div>
                <div class="goods-info-two" v-for="(i,index) in outData.out_d" :key="index">
                    <div class="info-order-h">
                        <div style="width: 50%;display: flex;align-items: center">
                            <div class="right-twenty">货号</div>
                            <div class="data-order">{{i.number}}</div>
                        </div>
                        <div style="width: 50%;display: flex;align-items: center">
                            <div class="right-twenty" >产品名称</div>
                            <div class="data-order">{{i.name}}</div>
                        </div>
                    </div>
                    <div class="sp-db-h">
                        <div class="right-twenty">供应商型号</div>
                        <div class="data-order">{{i.supplier_xh}}</div>
                    </div>
                    <div class="sp-db-h">
                        <div class="right-twenty">规格</div>
                        <div class="data-order" style="text-align: left">{{i.size}}</div>
                    </div>
                    <div class="info-order-h">
                        <div style="width: 50%;display: flex;">
                            <div class="right-twenty">卷号</div>
                            <div class="data-order">{{i.reel}}</div>
                        </div>
                        <div style="width: 50%;display: flex;">
                            <div class="right-twenty">卷号描述</div>
                            <div class="data-order">{{i.reel_detail}}</div>
                        </div>
                    </div>
                    <div class="info-order-h">
                        <div style="width: 50%;display: flex;">
                            <div class="right-twenty">数量</div>
                            <div class="data-order">
                                <!--<input style="width: 2rem">-->
                                <span>{{i.num}}</span>
                            </div>
                        </div>
                        <div style="width: 50%;display: flex;">
                            <div class="right-twenty">计量单位</div>
                            <div class="data-order">{{i.unit}}</div>
                        </div>
                    </div>
                    <div class="sp-db-h">
                        <div class="right-twenty">已出库数量</div>
                        <div class="data-order">{{i.num}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else style="text-align: center">
            <span>请用扫码枪扫描</span>
            <input id="scanQRCode" @keyup.enter="getData()" v-model="id" style="width: 0.5px;height: 0.5px;position: absolute;left: 0">
        </div>
    </div>
</template>

<script>
  import {mapState,mapMutations} from 'vuex'
  import { Toast } from 'vant';
  export default {
    name: "orderInfo",
    data(){
      return{
        title:'出库单',
        id:'',
        msg:''
      }
    },
    mounted(){
      this.getOutData('')
      this.focus()
    },
    computed: {
      ...mapState({
        outData: state => state.outData,
      })
    },
    methods:{
      ...mapMutations([
        'getOutData',
      ]),
      goScan(){
        let url = 'http://cs.lcyjfz.com/home/scan?url=orderInfo'
        window.location.href = url
      },
      focus() {
        onload = function () {
          var alem = document.getElementById('scanQRCode');
          alem.focus();
          var len = 0;
          len = alem.value.length + 1;

          if (len == 0) {
            return;
          }

          if (alem.createTextRange) {  //IE浏览器
            var sel = alem.createTextRange();
            sel.moveStart("character", len);
            sel.collapse();
            sel.select();
          }
          else {           //非IE浏览器   包括mozilla，chrome，safari
            alem.selectionStart = len;
          }
        }
      },
      async getData(){
        let packing = await this.get(this.APIOBJ.chukuGoodsorder,{gck_number:this.id})
        if(packing.data.data !== undefined){
          this.getOutData(packing.data.data)
        }
        if(packing.data.status === 0){
          Toast(packing.data.msg)
        }
        this.id = ''
      }
    }
  }
</script>

<style lang="less">
    @import "../style/orderinfo.less";
    *{
        font-size: 0.32rem;
    }
    .bottom-div{
        position: fixed;
        bottom: 0;
        width: 10rem;
        margin-left: -10px;
        background-color: dodgerblue;
        color: white;
        height: 1.5rem;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>